
export type ScoreboardState = {
  id: string;
  kit_id: string;
  team_a_score: number;
  team_b_score: number;
  team_a_hits: number;
  team_a_errors: number;
  team_b_hits: number;
  team_b_errors: number;
  balls: number;
  strikes: number;
  outs: number;
  inning: number;
  is_top_inning: boolean;
  base_runners: boolean[];
  team_a_name: string | null;
  team_a_primary_color: string | null;
  team_a_secondary_color: string | null;
  team_a_logo_url: string | null;
  team_b_name: string | null;
  team_b_primary_color: string | null;
  team_b_secondary_color: string | null;
  team_b_logo_url: string | null;
  created_at: string;
  updated_at: string;
};

export type NewScoreboardState = Omit<ScoreboardState, 'id' | 'created_at' | 'updated_at'>;
export type UpdateScoreboardState = Partial<NewScoreboardState>;

export const defaultScoreboardState: Omit<ScoreboardState, 'id' | 'kit_id' | 'created_at' | 'updated_at'> = {
  team_a_score: 0,
  team_b_score: 0,
  team_a_hits: 0,
  team_a_errors: 0,
  team_b_hits: 0,
  team_b_errors: 0,
  balls: 0,
  strikes: 0,
  outs: 0,
  inning: 1,
  is_top_inning: true,
  base_runners: [false, false, false],
  team_a_name: null,
  team_a_primary_color: '#D3E4FD',
  team_a_secondary_color: '#84CBE3',
  team_a_logo_url: null,
  team_b_name: null,
  team_b_primary_color: '#D3E4FD',
  team_b_secondary_color: '#84CBE3',
  team_b_logo_url: null,
};
